/* eslint-disable no-useless-catch */
import { AxiosResponse } from 'axios';

import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/customer-groups';

export const CustomerGroupApi = {
  select: async (option: any) => {
    const url = `${pathname}/select`;

    const { entityIDs } = option || {};
    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: any) => {
    let url = `${pathname}/filter`;

    const { entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerInGroup: async (id: string, option: any) => {
    let url = `${pathname}/find-customer-in-group/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterCustomerGroupForUpdate: async (id: string, option: any) => {
    let url = `${pathname}/filter-for-change-group/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerAddInGroup: async (id: string, option: any) => {
    let url = `${pathname}/find-customer-for-add-customer-in-group/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  addCustomerInGroup: async (id: string, body: any) => {
    const url = `${pathname}/multi/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  addMultiCustomerGroupForCustomer: async (id: string, body: any) => {
    const url = `${pathname}/multi-group/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteCustomerInGroup: async (id: string, body: any) => {
    const url = `${pathname}/multi/delete/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (
    option?: CheckDuplicateCustomerGroupCodeQuery
  ): Promise<AxiosResponse<void>> => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async () => {
    const url = `${pathname}/generate-code`;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CheckDuplicateCustomerGroupCodeQuery {
  code: string;
}

export interface FilterCustomerGroupOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityIDs?: string;
  status?: number;
  type?: number;
}

export interface FindAccountToCreateCustomerGroupQuery {
  page: number;
  take: number;
  order?: any;
  phoneNumber: string;
}
